(function () {
  if (window.__AG_PB_PRODUCT_PLANS_INIT__) return;
  window.__AG_PB_PRODUCT_PLANS_INIT__ = true;

  // The Eyr campaign engine adds the campaign's gifts after the cart changes. Going to checkout straight away
  // would leave the page before it has, so wait for its check (at most 4 seconds), then go.
  function agGoToCheckout() {
    var engine = window.EyrCampaignEngine;
    var go = function () { window.location.href = '/checkout'; };
    if (!engine || typeof engine.sync !== 'function') return go();
    var done = false;
    var once = function () { if (!done) { done = true; go(); } };
    setTimeout(once, 4000);
    try { Promise.resolve(engine.sync()).then(once, once); } catch (e) { once(); }
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function openMiniCart(cartData) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cartData, openMiniCart: true }
      })
    );

    var cartDrawer = document.querySelector('cart-drawer, #mini-cart');
    if (cartDrawer) {
      cartDrawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    if (typeof updateCartItemCount === 'function') {
      updateCartItemCount();
    }

    document.dispatchEvent(new CustomEvent('cart:changed', { bubbles: true }));
  }

  function selectCard(root, card) {
    qsa('[data-ag-pb-pp-card]', root).forEach(function (el) {
      el.classList.toggle('is-selected', el === card);
    });
  }

  function initSelection(root) {
    var cards = qsa('[data-ag-pb-pp-card]', root);
    if (!cards.length) return;

    var hasDefault = cards.some(function (c) {
      return c.getAttribute('data-default-selected') === 'true';
    });
    if (!hasDefault) {
      cards[0].classList.add('is-selected');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('button, a, input, label')) return;
        selectCard(root, card);
      });
    });
  }

  function initAtc(root) {
    var mode = (root.getAttribute('data-cta-mode') || 'cart').toLowerCase();

    qsa('[data-ag-pb-pp-form]', root).forEach(function (form) {
      if (form.dataset.agPbPpAtcReady === 'true') return;
      form.dataset.agPbPpAtcReady = 'true';

      var inflight = false;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (inflight) return;

        var card = form.closest('[data-ag-pb-pp-card]');
        if (card) selectCard(root, card);

        var idInput = qs('input[name="id"]', form);
        var spInput = qs('input[name="selling_plan"]', form);
        var qtyInput = qs('input[name="quantity"]', form);
        var variantId = idInput ? String(idInput.value || '').trim() : '';
        var spRaw = spInput ? String(spInput.value || '').trim() : '';
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        if (!qty || qty < 1) qty = 1;

        if (!/^\d+$/.test(variantId)) {
          console.error('[AG Product Plans] Missing/invalid variant id');
          return;
        }

        var item = { id: Number(variantId), quantity: qty };
        if (/^\d+$/.test(spRaw)) item.selling_plan = spRaw;

        var btn = qs('[data-ag-pb-pp-cta]', form);
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
        }
        inflight = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (res) {
            return res.json().then(function (body) {
              if (!res.ok) throw body;
              return body;
            });
          })
          .then(function (addBody) {
            if (mode === 'checkout') {
              agGoToCheckout();
              return;
            }

            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) {
                return r.json();
              })
              .then(function (cart) {
                openMiniCart(cart || addBody);
              })
              .catch(function () {
                openMiniCart(addBody);
              });
          })
          .catch(function (err) {
            console.error('[AG Product Plans ATC ERROR]', err);
          })
          .finally(function () {
            inflight = false;
            if (btn && mode !== 'checkout') {
              btn.disabled = false;
              btn.removeAttribute('aria-busy');
            }
          });
      });
    });
  }

  function initBlock(root) {
    if (!root || root.dataset.agPbPpReady === 'true') return;
    root.dataset.agPbPpReady = 'true';
    initSelection(root);
    initAtc(root);
  }

  function initAll() {
    qsa('[data-ag-pb-product-plans]').forEach(initBlock);
  }

  function placeForViewport(root) {
    var slotId = root.getAttribute('data-ag-pb-pp-mobile-slot');
    if (!slotId) return;

    var wrap = root.closest('.shopify-block, [id^="shopify-block-"]') || root;
    var markerSel = '[data-ag-pb-pp-block-home="' + root.id + '"]';
    var marker = document.querySelector(markerSel);

    if (!marker && wrap.parentNode) {
      marker = document.createElement('div');
      marker.setAttribute('data-ag-pb-pp-block-home', root.id);
      marker.hidden = true;
      wrap.parentNode.insertBefore(marker, wrap);
    }

    var slot = document.querySelector('[data-ag-pb-slot="' + slotId + '"]');
    var mobile = window.matchMedia('(max-width: 740px)').matches;

    if (mobile && slot) {
      var slotHost = slot.closest('.shopify-block, [id^="shopify-block-"]') || slot;
      slotHost.insertAdjacentElement('afterend', wrap);
    } else if (marker) {
      marker.insertAdjacentElement('afterend', wrap);
    }
  }

  function placeAll() {
    qsa('[data-ag-pb-product-plans][data-ag-pb-pp-mobile-slot]').forEach(placeForViewport);
  }

  function boot() {
    placeAll();
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);

  if (window.matchMedia) {
    var mq = window.matchMedia('(max-width: 740px)');
    if (mq.addEventListener) {
      mq.addEventListener('change', placeAll);
    } else if (mq.addListener) {
      mq.addListener(placeAll);
    }
  }
})();
